import type { AIConversationKind } from 'services/compose/suggest/net'
import type { ComposerContentDialogTab } from 'services/ui/state'
import type { SearchMode } from 'components/Composer/MediaSearchPanel'

export interface ComposerDeepLinkConfig {
  tab: ComposerContentDialogTab
  kind?: AIConversationKind
  searchMode?: SearchMode
}

export const COMPOSER_DEEP_LINKS: Record<string, ComposerDeepLinkConfig> = {
  '/composer/ai': { tab: 'generate', kind: 'image' },
  '/composer/ai/caption': { tab: 'generate', kind: 'text' },
  '/composer/ai/history': { tab: 'ai-content' },
  '/composer/library': { tab: 'search', searchMode: 'library' },
  '/composer/favorites': { tab: 'search', searchMode: 'favorites' },
  '/composer/stock': { tab: 'search', searchMode: 'stock' },
  '/composer/ideas': { tab: 'ideas' },
  '/composer/studio': { tab: 'edit' }
}
